<template>
  <div id="data-list-list-view" class="data-list-container">
    <!-- <div class="d-flex" style="display: flex;    align-items: center; justify-content: space-between; margin-bottom: 30px;">
       <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Reports</vs-button>
     </div> -->
    <vx-card
      collapse-action
      refresh-content-action
      @refresh="closeCardAnimationDemo"
    >
      <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        v-if="trackings"
        search
        :data="trackings || []"
        v-model="selected"
        @selected="
          $router.push(
            '/tracking/' +
              selected.id +
              `?date=${$dayjs(customDate).format('YYYY-MM-DD')}`
          )
        "
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-end pr-12"
        >
          <div
            class="flex flex-wrap-reverse gap-4 items-center data-list-btn-container"
          >
            <v-date-picker
              @input="getFilterData"
              v-model="customDate"
              style="z-index: 9999"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <vs-input
                  class="bg-white border px-2 py-1 rounded"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </template>
            </v-date-picker>
            <div class="flex items-center gap-1">
              <button
                @click="setPreviousDate"
                class="p-2 flex items-center justify-center cursor-pointer border-none rounded-lg bg-grey"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                  class="w-5 h-5 mr-1"
                ></feather-icon>
              </button>
              <button
                @click="setNextDate"
                class="p-2 flex items-center justify-center cursor-pointer border-none rounded-lg bg-grey"
              >
                <feather-icon
                  icon="ArrowRightIcon"
                  class="w-5 h-5 mr-1"
                ></feather-icon>
              </button>
            </div>
          </div>
          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th sort-key="data">No</vs-th>
          <vs-th sort-key="vehicle">Driver</vs-th>
          <vs-th sort-key="driver">Truck no.</vs-th>
          <vs-th sort-key="origin">Status</vs-th>
          <vs-th sort-key="duration">Last known location</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody class="nmadir">
            <vs-tr
              class="hover:bg-primary hover:text-white"
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
            >
              <vs-td>
                {{ indextr + 1 }}
              </vs-td>
              <vs-td>
                {{ tr.name + " " + tr.last_name }}
              </vs-td>
              <vs-td>
                <p class="product-category flex items-center gap-2">
                  <feather-icon
                    icon="TruckIcon"
                    class="w-5 h-5 text-success"
                  ></feather-icon>
                  {{ tr.vehicle_id }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category flex items-center gap-2">
                  {{ tr.status.status }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category flex items-center gap-2">
                  {{ tr.status.country }}
                  <br />
                  <span>
                    {{ $dayjs(tr.status.cr_time).format("YYYY-MM-DD HH:MM") }}
                  </span>
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
  
  <script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      fileName: "",
      activePrompt: false,
      selected: [],
      // products: [],
      itemsPerPage: 6,
      isMounted: false,
      driver_id: null,
      customDate: new Date(),
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    trackings() {
      return this.$store.state.log.trackings;
    },
  },
  methods: {
    getFilterData() {
      this.$store.dispatch("log/fetchTrackings", {
        day: dayjs(this.customDate).format("YYYY-MM-DD"),
      });
    },
    setNextDate() {
      const currentDate = new Date(this.customDate);
      const nextDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000); // Add one day (in milliseconds)
      this.customDate = nextDate.toISOString().split("T")[0];
    },
    setPreviousDate() {
      const currentDate = new Date(this.customDate);
      const previousDate = new Date(
        currentDate.getTime() - 24 * 60 * 60 * 1000
      ); // Subtract one day (in milliseconds)
      this.customDate = previousDate.toISOString().split("T")[0];
    },
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
      setTimeout(() => {
        this.getFilterData();
      }, 3000);
    },
  },
  created() {
    this.getFilterData();
  },
  mounted() {
    this.isMounted = true;
    this.$store.dispatch("log/fetchTrackings");
  },
};
</script>
  